import { style } from "@vanilla-extract/css";

/**
 * Container for the radial menu.
 * Uses relative positioning to anchor the absolutely positioned options.
 */
export const containerStyle = style({
  position: "relative",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
});

/**
 * Style for the trigger button wrapper to handle z-index layering.
 */
export const triggerWrapperStyle = style({
  position: "relative",
  zIndex: 2,
});

/**
 * Container for menu options with role="menu".
 * Positioned at the center point with zero dimensions.
 * Child options are positioned absolutely from this center point.
 */
export const menuContainerStyle = style({
  position: "relative",
  width: 0,
  height: 0,
  pointerEvents: "none",
});
